import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cosmos',
  templateUrl: './cosmos.component.html',
  styleUrls: ['./cosmos.component.css']
})
export class CosmosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
